module.exports = __webpack_public_path__ + "static/media/communication.ec09cc16.svg";